/** ******** 系统安全模块 ********* */
export const getDeviceAuthList = {
  url: '/admin/equipment/limit/queryEuipmentInfo.json',
  method: 'get'
};

// 导出设备列表
export const exportDeviceAuthList = {
  url: '/admin/equipment/limit/exportEquipmentInfo.json'
};

export const updateDeviceAuth = {
  url: '/admin/equipment/limit/editLimitStatus.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const setNote = {
  url: '/admin/equipment/limit/setNoteInfo.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const getCusServiceInfo = {
  url: '/admin/equipment/limit/showMaintenance.json',
  method: 'get'
};

export const saveCusServiceInfo = {
  url: '/admin/equipment/limit/maintenancePhone.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 保存密码
export const savePwd = {
  url: '/admin/accountSafe/savePassword.json',
  method: 'get'
};

// 埋点
export const trackData = {
  url: '/admin/track/get_data.json',
  method: 'get'
}
export const trackCountData = {
  url: '/admin/track/get_count.json',
  method: 'get'
}
export const trackAccountDetail = {
  url: '/admin/track/getAccountDetail.json',
  method: 'get'
}